import React, { useState, useEffect } from 'react'
import {
    Box,
    Button,
    Modal,
    Typography,
    IconButton,
    TextField,
    MenuItem,
    FormControl,
    Select,
    FormHelperText,
    CircularProgress
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useSelector, useDispatch } from 'react-redux'
import { imageUpload, clearImageRes } from '../../redux/slices/investments'
import CancelIcon from '@mui/icons-material/Cancel'
import PhoneInput from "../../components/phoneInput";
import {
    Grid,
    Autocomplete
} from '@mui/material'
import FormLabel from '../label'
import CtaButton from '../buttonWithArrow'
import { lockScroll, unlockScroll } from '../../utils/scrollLock'
import AfterFormSubmit from './AfterFormSubmit';
// import { countries } from '../../data/countries';

const pillInputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: 999,
        bgcolor: "#fff",
    },
};


const style = {
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        backgroundColor: "rgba(0,0,0,0.6)", // dimmed background
    },
    container: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        px: { xs: 2, sm: 3 },
        py: 2,
        borderBottom: "1px solid #eee",
        bgcolor: "#fff",
    },
    header: {
        fontWeight: 700,
        fontSize: 24,
        mb: 2
    },
    closeBtn: { position: "absolute", top: 8, right: 8, width: 36, height: 36 },
    input: {
        width: '100%',
        mb: 2,
        backgroundColor: '#f3f3f3',
        borderRadius: '12px',
        input: {
            padding: '22px 14px'
        },
        '& .MuiFilledInput-root': {
            backgroundColor: '#f3f3f3',
            borderRadius: '12px',
            boxShadow: 'none',
            '&:before': {
                borderBottom: '0 !important' // removes the bottom underline
            },
            '&:after': {
                borderBottom: '0 !important' // removes the focus underline
            },
            '&:hover:before': {
                borderBottom: '0 !important'
            }
        },
        '& .MuiFormHelperText-root': {
            marginLeft: 0
        }
    },
    select: {
        width: '100%',
        mb: 2,
        backgroundColor: '#f3f3f3',
        borderRadius: '12px',

        '& .MuiFilledInput-root': {
            backgroundColor: '#f3f3f3',
            borderRadius: '12px',
            paddingTop: '12px',
            paddingBottom: '12px',
            '&:before, &:after, &:hover:before': {
                borderBottom: '0 !important'
            }
        },
        '& .MuiSelect-filled': {
            padding: '12px 14px',
            backgroundColor: '#f3f3f3'
        }
    },
    submitBtn: {
        background: 'linear-gradient(to right, #9CD0C9, #32788E)',
        color: '#fff',
        fontWeight: 600,
        borderRadius: '12px',
        fontSize: '16px',
        textTransform: 'none',
        mt: 2,
        py: 1.2
    },
    fileInputBox: {
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        // bgcolor: "#f3f3f3",
        borderRadius: 999,
        px: 2,
        py: 1.5,
        mb: 2,
        border: "1px solid #c4c4c4",
    },
    chooseBtn: {
        background: "linear-gradient(to right, #9CD0C9, #32788E)",
        color: "#fff",
        fontWeight: 600,
        borderRadius: "10px",
        fontSize: 13,
        px: 2,
        py: 0.75,
        textTransform: "none",
        "&:hover": {
            opacity: 0.95,
        },
    },
    fileRemoveBtn: {
        color: "#7bcbc4",
        "&:hover": { color: "#5fbab2" },
    },
}

/* Mirrors the /document/uploadTempSingle contract: the API keys both the
   allowed extensions and the max size off the "type" field we send, so the
   extension decides which type a file is uploaded as. */
const UPLOAD_RULES = {
    image: {
        extensions: ["jpg", "jpeg", "png", "webp"],
        maxSizeMb: 5,
        mimeTypes: ["image/jpeg", "image/png", "image/webp"],
    },
    document: {
        extensions: ["pdf", "docx", "xlsx", "json"],
        maxSizeMb: 10,
        mimeTypes: [
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/json",
        ],
    },
};

const DOCUMENT_ACCEPT = Object.values(UPLOAD_RULES)
    .flatMap(({ extensions, mimeTypes }) => [...mimeTypes, ...extensions.map((ext) => `.${ext}`)])
    .join(",");

const DOCUMENT_SUPPORTED_TEXT = `Supported Format: ${UPLOAD_RULES.image.extensions
    .join(", ")
    .toUpperCase()} (max ${UPLOAD_RULES.image.maxSizeMb}MB), ${UPLOAD_RULES.document.extensions
    .join(", ")
    .toUpperCase()} (max ${UPLOAD_RULES.document.maxSizeMb}MB)`;

const getFileExtension = (file) => (file?.name || "").split(".").pop().toLowerCase();

// Returns "image" | "document" for a supported file, otherwise null.
const getUploadType = (file) => {
    if (!file) return null;
    const extension = getFileExtension(file);
    return Object.keys(UPLOAD_RULES).find((type) =>
        UPLOAD_RULES[type].extensions.includes(extension)
    ) ?? null;
};

export default function EnquireFormModal({
    open,
    onClose,
    fleetCard = [],
    handleSubmit, loader, setLoader, apiResponse, labels = ["Name", "Email", "Phone", "Select Type", "Document"]
}) {
    const dispatch = useDispatch()
    const { imageRes } = useSelector(state => state.investment)
    const [statusMessage, setStatusMessage] = useState('');
    const [status, setStatus] = useState(null);
    const [enquiryOpen, setEnquiryOpen] = useState(false)
    const [imageLoader, setImageLoader] = useState(false);
    const [imageMessage, setImageMessage] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        countryCode: '971',
        phone: '',
        itemId: '',
        itemInfo: null,
        document: null,
    })

    const [errors, setErrors] = useState({})


    // console.log("formData", formData);

    // console.log("true",  labels.includes("Select Jet"));



    useEffect(() => {
        if (open) lockScroll();
        else unlockScroll();

        return () => unlockScroll(); // cleanup if component unmounts
    }, [open]);


    const handleChange1 = e => {
        const selectedId = e.target.value
        const info = fleetCard?.find((item) => item?._id === selectedId);
        setFormData(prev => ({
            ...prev,
            itemId: selectedId,
            itemInfo: info
        }))
    }

    const resetForm = () => {
        setFormData({
            name: '',
            email: '',
            countryCode: '971',
            phone: '',
            itemId: '',
            itemInfo: null,
            document: null,
        })
        setErrors({});
        setImageMessage(null);
    }

    const handleClickOpen = () => {
        setEnquiryOpen(true)
    }

    const handleClose = () => {

        console.log("handleClose called")
        if (statusMessage === '' && status === 1) {
            // setOpen(false);
            onClose();
        }
        setEnquiryOpen(false)

    }


    // console.log("apiResponse",apiResponse);


    useEffect(() => {
        if (apiResponse && loader) {
            setLoader(false)
            dispatch(clearImageRes());

            if (apiResponse.status === 1) {
                handleClickOpen()
                resetForm()
                setStatusMessage('')
                setStatus(apiResponse.status);
            } else {
                handleClickOpen()
                setStatus(-1)
                setStatusMessage(apiResponse.message || `We’re sorry! Something went wrong. Please try again in a few moments.`)
            }
        }
    }, [apiResponse])




    // const handleFileChange = (e, field) => {
    //     setFormData({ ...formData, [field]: e.target.files[0] })
    //     e.target.value = null
    // }

    const validate = () => {
        const newErrors = {}
        if (!formData.name.trim()) newErrors.name = 'Name is required'
        else if (!/^[A-Za-z\s]+$/.test(formData.name))
            newErrors.name = 'Only letters and spaces allowed'

        if (!formData.email) newErrors.email = 'Email is required'
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
            newErrors.email = 'Enter a valid email address'

        if (!formData.phone) newErrors.phone = 'Phone number is required'
        else if (!/^\d{7,15}$/.test(formData.phone))
            newErrors.phone = 'Enter a valid phone number (7–15 digits)'

        if (!formData.itemId) newErrors.type = 'This field is required'

        return newErrors
    }

    const handleEnquirySubmit = async e => {
        e.preventDefault()

        const validationErrors = validate()
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length > 0) {
            setStatusMessage('Please fix the errors before submitting.')
            return
        }

        // const payload = new FormData()
        // payload.append('name', formData.name)
        // payload.append('phone', formData.phone)
        // payload.append('countryCode', formData.countryCode)
        // payload.append('email', formData.email)
        // payload.append('itemId', formData.itemId)
        // payload.append('userType', 1) // Assuming 1 is investor

        // if (formData.document) payload.append('document', formData.document)

        // for (let pair of payload.entries()) {
        //     console.log(pair[0] + ': ', pair[1])
        // }

        setStatusMessage('');
        handleSubmit(formData);
        // setLoader(true)
        // dispatch(investerFormSubmit(payload))
    }

    const handleEnquiryClose = () => {
        // console.log("called----->");
        onClose()
        resetForm()
    }


    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        setImageMessage(null);
        // Dispatch the upload file action
        if (selectedFile) {
            const uploadType = getUploadType(selectedFile);
            if (!uploadType) {
                e.target.value = null;
                setImageMessage(DOCUMENT_SUPPORTED_TEXT);
                return;
            }

            const { maxSizeMb } = UPLOAD_RULES[uploadType];
            if (selectedFile.size > maxSizeMb * 1024 * 1024) {
                e.target.value = null;
                setImageMessage(`File is too large. Maximum size for ${uploadType}s is ${maxSizeMb}MB.`);
                return;
            }

            setImageLoader(true); // Set loader while uploading the file            
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('type', uploadType);
            // Dispatch the upload action
            dispatch(imageUpload(formData));
        }
        e.target.value = null; // allow re-picking the same file after a failure
    };

    useEffect(() => {
        if (imageRes) {
            setImageLoader(false);
            if (imageRes?.status === 1) {
                setImageMessage(null);
                setFormData({ ...formData, ["document"]: imageRes?.path });
            } else {
                setImageMessage(imageRes?.message);
                setFormData({ ...formData, ["document"]: null });
            }
        }
    }, [imageRes])

    return (
        <>
            <Modal
                open={open}
                onClose={handleEnquiryClose}
                sx={style.modal}
                scroll='body'
            >
                {/* Shell */}
                <Box
                    sx={{
                        position: "relative",
                        width: 680,
                        maxHeight: { xs: "92vh", sm: "90vh" },   // <-- controls total modal height
                        bgcolor: "#fff",
                        borderTopLeftRadius: { xs: 12, sm: 16 },
                        borderTopRightRadius: { xs: 12, sm: 16 },
                        borderRadius: { sm: 4 },
                        boxShadow: "0 18px 60px rgba(0,0,0,.25)",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    <Box sx={style.container}>
                        <Typography sx={{ fontWeight: 800, fontSize: { xs: 18, sm: 22, md: 24 } }} className="jura">Enquire</Typography>
                        <IconButton
                            onClick={handleEnquiryClose}
                            sx={style.closeBtn}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box
                        sx={{
                            px: { xs: 2, sm: 3 },
                            overflowY: "auto",
                            flex: 1,
                            // helps value label of slider not get clipped
                            "&& .MuiSlider-root": { overflow: "visible" },
                        }}
                    >
                        <Grid container spacing={2} sx={{ mt: 0 }}>
                            <Grid item xs={12}>
                                <FormLabel label={labels[0]} required />
                                <TextField
                                    fullWidth
                                    placeholder={`Enter ${labels[0]}`}
                                    name="name"
                                    value={formData.name}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    onChange={e => {
                                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, '')
                                        setFormData({ ...formData, name: onlyLetters })
                                    }}
                                    sx={pillInputSx}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormLabel label={labels[1]} required />
                                <TextField
                                    fullWidth
                                    placeholder='john@example.com'
                                    value={formData.email}
                                    name="email"
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    onChange={e => setFormData({ ...formData, email: e.target.value })}
                                    sx={pillInputSx}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormLabel label={labels[2]} required />
                                <Box sx={{ display: "flex", mb: 2 }}>
                                    {/* Country Code Selector */}
                                    {/* <Autocomplete
                                        disableClearable
                                        options={countries}
                                        getOptionLabel={(option) => `${option.code} (+${option.phone})`}
                                        filterOptions={(options, { inputValue }) =>
                                            options.filter(
                                                (option) =>
                                                    option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                    option.code.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                    option.phone.includes(inputValue.replace("+", ""))
                                            )
                                        }
                                        value={countries.find((c) => c.phone === formData.countryCode) || countries[0]}
                                        onChange={(e, value) => {
                                            if (value) setFormData({ ...formData, countryCode: value.phone });
                                        }}
                                        sx={{
                                            width: "35%",
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "999px 0 0 999px",
                                            },
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <span style={{ marginRight: 8 }}>
                                                    {String.fromCodePoint(
                                                        ...[...option.code.toUpperCase()].map((c) => 127397 + c.charCodeAt())
                                                    )}
                                                </span>
                                                {option.code} (+{option.phone})
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "999px 0 0 999px",
                                                    },
                                                }}
                                            />
                                        )}
                                    /> */}

                                    {/* Phone Number Input */}
                                    {/* <TextField
                                        fullWidth
                                        placeholder={`Enter ${labels[2]}`}
                                        value={formData.phone}
                                        name="phone"
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                phone: e.target.value.replace(/\D/g, '')
                                            })
                                        }
                                        error={!!errors.phone}
                                        helperText={errors.phone}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "0 999px 999px 0", // rounded right side
                                                bgcolor: "#fff",
                                            }
                                        }}
                                    /> */}

                                    <PhoneInput
                                        value={formData.phone}
                                        countryCode={formData.countryCode}
                                        onChange={(countryCode, phone) =>
                                            setFormData((prev) => ({ ...prev, countryCode, phone }))
                                        }
                                        error={!!errors.phone}
                                        helperText={errors.phone}
                                        width="100%"
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <FormLabel label={labels[3]} required />
                                <FormControl fullWidth error={!!errors.type} sx={{ ...pillInputSx, "& fieldset": { borderRadius: 999 } }}>
                                    <Select
                                        displayEmpty
                                        value={formData.itemId}
                                        name="type"
                                        onChange={handleChange1}
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return <span style={{ color: "#808890" }}>{labels[3]}</span>;
                                            }
                                            const selectedItem = fleetCard?.find((item) => item?._id === selected);
                                            return selectedItem ? selectedItem?.name : "";
                                        }}
                                    >
                                        {fleetCard?.map((item) => (
                                            <MenuItem key={item?._id} value={item?._id}>
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{errors.type ? errors.type : " "}</FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormLabel label={labels[4]} />
                                <Box
                                    sx={{
                                        border: "1px solid #E5E5E5",
                                        borderRadius: "27px",
                                        p: 2,
                                        textAlign: "center",
                                        mb: 2,
                                    }}
                                >
                                    <input
                                        id="document-upload"
                                        type="file"
                                        hidden
                                        accept={DOCUMENT_ACCEPT}
                                        disabled={imageLoader}
                                        onChange={(e) => handleFileChange(e)}
                                    />
                                    {!formData.document ? (
                                        <label htmlFor="document-upload" style={{ cursor: "pointer" }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 1,
                                                }}
                                            >
                                                {
                                                    imageLoader ? <CircularProgress
                                                        sx={{
                                                            width: "20px !important",
                                                            height: "20px !important",
                                                            color: "#0f7f8a",
                                                        }}
                                                    /> :
                                                        <img
                                                            src="/img/investments/limousine/upload.svg"
                                                            alt="upload"
                                                            width={60}
                                                        />
                                                }

                                                <Typography
                                                    color="#2A7B8F"
                                                    sx={{
                                                        fontSize: 13,
                                                        fontWeight: 500,
                                                        textDecoration: "underline",
                                                    }}
                                                >
                                                    Click here to upload your file.
                                                </Typography>
                                                {
                                                    imageMessage ? <Typography color="red" sx={{ fontSize: 12 }}>
                                                        {imageMessage}
                                                    </Typography> : <Typography color="#A0A0A0" sx={{ fontSize: 12 }}>
                                                        {DOCUMENT_SUPPORTED_TEXT}
                                                    </Typography>
                                                }

                                            </Box>
                                        </label>
                                    ) : (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                px: 2,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: 14,
                                                    color: "#333",
                                                    textAlign: "left",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    maxWidth: "80%",
                                                }}
                                                title={formData.document}
                                            >
                                                {formData.document}
                                            </Typography>

                                            <IconButton
                                                size="small"
                                                onClick={() => setFormData({ ...formData, document: null })}
                                            >
                                                <CancelIcon fontSize="small" sx={{ color: "#7bcbc4" }} />
                                            </IconButton>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>


                        </Grid>

                        {/* Footer (sticky) */}
                        <Box
                            sx={{
                                position: "sticky",
                                bottom: 0,
                                zIndex: 1,
                                px: { xs: 2, sm: 3 },
                                py: { xs: 2, sm: 2 },
                                borderTop: "1px solid #eee",
                                bgcolor: "#fff",
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <CtaButton label="Submit" onClick={handleEnquirySubmit}
                                loader={loader}
                            />
                        </Box>
                    </Box>
                </Box>
            </Modal>
            <AfterFormSubmit open={enquiryOpen} status={status} message={statusMessage} onClose={handleClose} Catalog={statusMessage === ""} />
        </>
    )
}
